module.exports = __webpack_public_path__ + "static/media/066-news.be288e7a.svg";